/**
 * NameField - Full name input field
 *
 * Features:
 * - Captures name on blur for lead updates
 */

import type { UseFormRegisterReturn } from 'react-hook-form';
import { FormField } from './FormField';

interface NameFieldProps {
  /** react-hook-form registration object */
  registration: UseFormRegisterReturn;
  /** Error message from form validation */
  error?: string;
  /** Whether the field is disabled */
  disabled?: boolean;
  /** Callback when name should be captured (on blur with non-empty value) */
  onNameCapture?: (name: string) => void;
}

export function NameField({ registration, error, disabled, onNameCapture }: NameFieldProps) {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    registration.onBlur(e);

    // Capture name if non-empty
    const name = e.target.value.trim();
    if (name && onNameCapture) {
      onNameCapture(name);
    }
  };

  return (
    <FormField
      label="Full name"
      name={registration.name}
      ref={registration.ref}
      type="text"
      placeholder="Jane Doe"
      autoComplete="name"
      onChange={registration.onChange}
      onBlur={handleBlur}
      error={error}
      disabled={disabled}
    />
  );
}

export default NameField;
